import React, { useContext, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTrash } from '@fortawesome/free-solid-svg-icons';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button,
    Form, FormGroup, FormText
} from 'reactstrap';
import Axios from 'axios';
import { toast } from 'react-toastify';

import { AuthContext } from '../../../../../Data/AuthContext';
import ProgressIndicator from '../../../../Common/ProgressIndicator';
import TextFieldGroup from '../../../../Common/TextFieldGroup';
import SelectFieldGroup from '../../../../Common/SelectFieldGroup';
import { postTypeToString } from '../../../../../Utils/Converters';
import { USER, ORGANISER, MEMBER, GUEST } from '../../../../../Data/Constants';

function RegistrationModal(props) {
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [registration, setRegistration] = useState({});
    const [error, setError] = useState({});
    const auth = useContext(AuthContext);
    const { event } = props;

    useEffect(() => {
        if (props.registration != null)
            setRegistration(props.registration);
    }, [props]);

    function handleChange(e) {
        e.persist();
        setRegistration((prevState) => {
            return { ...prevState, [e.target.name]: e.target.value };
        });
    }

    function handleSubmit(e) {
        e.preventDefault();
        setIsSaving(true);
        let isGuest = registration.type == GUEST;
        let isOrganiser = registration.type == ORGANISER;

        Axios.post(`/events/${event.id}/registrations/${registration.id}`, {
            id: registration.id,
            type: Number(registration.type),
            guestName: isGuest ? registration.guestName : null,
            guestEmail: isGuest ? registration.guestEmail : null,
            steinCaption: registration.steinCaption,
            remark: registration.remark,
            post: isOrganiser ? Number(registration.post) : null,
            eventId: props.event.id
        }).then(res => {
            setIsSaving(false);
            toast.success("Jelentkezés mentve.");
            props.close();
            props.callback();
        }, err => {
            setError(err.errors);
            setIsSaving(false);
            toast.error("A jelentkezés mentése sikertelen.");
        });
    }

    function handleDelete(e) {
        setIsDeleting(true);
        Axios.get(`/events/${event.id}/registrations/${registration.id}/delete`).then(res => {
            setIsDeleting(false);
            toast.success("Jelentkezés törölve.");
            props.close();
            props.callback();
        }, err => {
            setError(err.errors);
            setIsDeleting(false);
            toast.error("A jelentkezés törlése sikertelen.");
        });
    }

    const isMember = auth.roles && auth.roles.includes(MEMBER);
    const steinRegistrationEnded = new Date(event.steinOrderDeadline) < new Date();

    const organiserFields = (
        <FormGroup row>
            <SelectFieldGroup className="col-lg-12"
                field="post"
                onChange={handleChange}
                label="Poszt"
                error={error.Post}
                value={registration.post}
            >
                {new Array(13).fill(0).map((_value, index) => {
                    return <option value={index} key={index}>{postTypeToString(index)}</option>;
                })}
            </SelectFieldGroup>
        </FormGroup>
    );

    const guestFields = (
        <FormGroup row>
            <TextFieldGroup className="col-lg-6"
                field="guestName"
                onChange={handleChange}
                label="Vendég neve"
                error={error.GuestName}
                value={registration.guestName}
            />
            <TextFieldGroup className="col-lg-6"
                field="guestEmail"
                onChange={handleChange}
                label="Vendég email címe"
                error={error.GuestEmail}
                value={registration.guestEmail}
            />
        </FormGroup>
    );

    if (isSaving || isDeleting)
        return (
            <Modal isOpen>
                <ModalHeader>{isSaving ? "Jelentkezés mentése" : "Jelentkezés törlése"}</ModalHeader>
                <ModalBody>
                    <ProgressIndicator />
                </ModalBody>
            </Modal>
        );

    if (registration)
        return (
            <Modal isOpen={props.isOpen} toggle={props.close}>
                <ModalHeader toggle={props.close}>
                    {registration.id === 0 ? "Jelentkezés a rendezvényre" : `${
                        registration.type === USER || registration.type === ORGANISER ?
                            registration.userName : registration.guestName} jelentkezésének szerkesztése`}
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit} id="eventRegistrationForm" >
                        <FormGroup>
                            {registration.type !== GUEST && isMember && <FormGroup row>
                                <SelectFieldGroup className="col-lg-12"
                                    field="type"
                                    onChange={handleChange}
                                    label="Jelentkezés típusa"
                                    error={error.Type}
                                    value={registration.type}>
                                    <option value={USER}>Normál</option>
                                    <option value={ORGANISER}>Rendező</option>
                                </SelectFieldGroup>
                            </FormGroup>}
                            {registration.type == GUEST && guestFields}
                            {registration.type == ORGANISER && organiserFields}
                            {event.stein &&
                                <FormGroup row>
                                    <TextFieldGroup className="col-lg-12"
                                        field="steinCaption"
                                        disabled={steinRegistrationEnded}
                                        onChange={handleChange}
                                        label="Korsóra kért felirat"
                                        error={error.SteinCaption}
                                        value={registration.steinCaption}>
                                        {!steinRegistrationEnded &&<FormText color="secondary">
                                            Ha nem kérsz korsót, hagyd üresen.<br />A korsó alapból tartalmaz egy emblémát a szakest nevével és az aktuális évszámmal.
                                        </FormText>}
                                        {steinRegistrationEnded &&<FormText color="secondary">
                                            A korsórendelési határidő lejárt, így a feliratot nem módosíthatod.
                                        </FormText>}
                                    </TextFieldGroup>
                                </FormGroup>}
                            <FormGroup row>
                                <TextFieldGroup className="col-lg-12"
                                    field="remark"
                                    onChange={handleChange}
                                    label="Megjegyzés"
                                    error={error.Remark}
                                    value={registration.remark}>
                                    <FormText color="secondary">
                                        Ha nem fogyasztasz alkoholt (alkoholimpotencia), vagy bármi más megjegyzésed van, ide írd.
                                    </FormText>
                                </TextFieldGroup>
                            </FormGroup>
                        </FormGroup>
                        {error[""]}
                    </Form >
                </ModalBody>
                {new Date(event.registrationDeadline) > new Date() && <ModalFooter>
                    {registration.id !== 0 && <Button color="warning" type="button" className="mr-auto" onClick={handleDelete}><FontAwesomeIcon icon={faTrash} /> Törlés</Button>}
                    <Button color="primary" type="submit" form="eventRegistrationForm"><FontAwesomeIcon icon={faCheck} /> Mentés</Button>
                </ModalFooter>}
            </Modal>
        );

    return null;
}

export default RegistrationModal;